<template>
    <div>
      <div class="action-buttons ">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group" v-if="groupedLocations">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.gestiune') }}</label>
              <el-select
                  v-model="selectedGestiune"
                  placeholder="Selectează gestiunea"
                  :disabled="loading"
                >
                <el-option
                  v-for="gestiune in filteredGestiuni"
                  :key="gestiune.id"
                  :label="gestiune.name"
                  :value="gestiune.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Date</label>
              <el-date-picker
                type="daterange"
                v-model="searchDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :name="['date_from', 'date_to']"
              ></el-date-picker>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Caută produs</label>
              <input
                type="text"
                class="form-control"
                placeholder="Caută după nume produs..."
                :disabled="loading"
                ref="searchTerm"
                v-model="searchTerm"
              />
            </div>
          </div>
         </div>
         <div class="right-buttons">
         </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="data-table">
                <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="width: 100%;">
                    <el-table-column prop="productDetails.name" :label="$t('gestiune.stockNameTable')" width="400"></el-table-column>
                    <el-table-column prop="productDetails.um" :label="$t('gestiune.stockUm')" width="100"></el-table-column>
                    <el-table-column prop="productDetails.stocMinim" :label="$t('gestiune.stockStocMinim')"></el-table-column>
                    <!-- <el-table-column prop="issueDate" :label="$t('invoice.issueDate')" :formatter="formatDate"></el-table-column> -->
                    <el-table-column prop="quantity" :label="$t('gestiune.stockQuantity')"></el-table-column>

                    <el-table-column :label="$t('gestiune.stockPrice')">
                      <template slot-scope="scope">
                        <template v-if="scope.row.productDetails">
                          {{ scope.row.productDetails.price }} {{ scope.row.productDetails.currency }}
                        </template>
                      </template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.stockValue')">
                      <template slot-scope="scope">
                        <template v-if="scope.row.value">
                          {{ scope.row.value }}
                        </template>
                        <template v-if="scope.row.productDetails && scope.row.productDetails.currency">
                          {{ scope.row.productDetails.currency }}
                        </template>
                      </template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.stockStatus')" width="200">
                      <template slot-scope="scope">
                        <template v-if="scope.row.productDetails && scope.row.productDetails.stocMinim !== null">
                          <span v-if="scope.row.quantity < scope.row.productDetails.stocMinim">{{$t('gestiune.stockStatus3')}}</span>
                          <span v-else-if="scope.row.quantity < scope.row.productDetails.stocMinim + 5">{{$t('gestiune.stockStatus1')}}</span>
                          <span v-else>{{$t('gestiune.stockStatus2')}}</span>
                        </template>
                        <template v-else>-</template>
                      </template>
                    </el-table-column>
                </el-table>
            </div>
           </div>
      </div>
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
// import swal from 'sweetalert2'

export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      searchDate: null,
      filter: {
        series: ''
      },
      searchTerm: null,
      searchTimeout: null,
      selectedGestiune: null,
      selectedLocation: null
    }
  },
  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  watch: {
    selectedLocation (newLocation) {
      this.selectedGestiune = null
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id
      }
      // if (!newLocation) {
      //   // Toate locațiile din groupedLocations
      //   const allLocations = this.groupedLocations.flatMap(group => group.locations)
      //   console.log('Fetching invoices for all locations:', allLocations)
      //   this.getData({ locations: allLocations })
      // } else {
      //   this.getData(newLocation)
      // }
    },
    searchDate (newGestiune) {
      this.searchTerm = null
      this.tableData = []
      if (this.selectedLocation && this.selectedGestiune) {
        this.getData()
      }
    },
    selectedGestiune (newGestiune) {
      this.searchTerm = null
      this.tableData = []
      if (this.selectedLocation && this.selectedGestiune) {
        this.getData()
      }
    },
    groupedLocations (newVal) {
      this.searchTerm = null
      this.firstLoad()
    },
    gestiuneOptions (newVal) {
      this.searchTerm = null
      this.firstLoad()
    },
    searchTerm () {
      this.tableData = []
      if (this.selectedLocation && this.selectedGestiune) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(async () => {
          await this.getData()
          this.$refs.searchTerm.focus()
        }, 300)
      }
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    this.firstLoad()
  },
  methods: {
    firstLoad () {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0]
      }
      // if (this.filteredGestiuni && this.filteredGestiuni.length) {
      //   setTimeout(() => { // next tic after selectedLocation watch
      //     this.selectedGestiune = this.filteredGestiuni[0].id
      //   }, 1)
      // }
    },
    formatDate (row, column, cellValue) {
      if (!cellValue) return ''
      return new Date(cellValue).toLocaleDateString()
    },
    async getData (date = null) {
      const externalCompanyId = this.companyID

      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = setTimeout(() => {
        this.loading = true
      }, 200)
      this.tableData = []

      if (!externalCompanyId) {
        return
      }
      if (!this.selectedGestiune) {
        return
      }

      let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/stock?externalCompanyId=${externalCompanyId}`
      if (date) {
        url += `&date=${date}`
      }
      if (this.selectedGestiune) {
        url += `&gestiune=${this.selectedGestiune}`
      }
      if (this.selectedLocation) {
        url += `&externalLocationId=${this.selectedLocation.true_id}`
      }
      if (this.searchTerm) {
        url += `&name=${encodeURIComponent(this.searchTerm)}`
      }
      if (this.searchDate && this.searchDate[0] && this.searchDate[0]) {
        url += `&startDate=${this.searchDate[0]}`
        url += `&endDate=${this.searchDate[1]}`
      }

      try {
        const response = await fetch(url)
        const data = await response.json()
        clearTimeout(this.loadingTimeout)
        this.loading = false
        if (Array.isArray(data.stock)) {
          this.tableData = data.stock
        } else {
          console.error('Invalid data format:', data)
        }
      } catch (error) {
        console.error('Error fetching invoices:', error)
      }
    },
    async downloadInvoice (row) {
      const series = row.series
      const invoiceNumber = row.invoiceNumber

      if (!series || !invoiceNumber) {
        alert('Missing series or invoice number.')
        return
      }

      const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/invoice/${series}-${invoiceNumber}/pdf`

      try {
        const response = await fetch(url)
        if (response.ok) {
          const blob = await response.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${series}-${invoiceNumber}.pdf`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          console.error('Error downloading invoice:', response.statusText)
        }
      } catch (error) {
        console.error('Error fetching invoice:', error)
      }
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}

.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Reports/StockReport.vue